import { TABLA_CAMIONES_RECHAZADOS_EN_BRUTO } from '../../../../../../config/tables'
import CamionesRechazadosPesado from '../../../../../../models/camiones/camiones_rechazados_pesado'
import { COLUMNS_CAMIONES_RECHAZADOS_BRUTO } from './constantesCamionesRechazados'

const CamionesRechazados = new CamionesRechazadosPesado()

export function actualizarDatos () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_RECHAZADOS_EN_BRUTO
    })
    CamionesRechazados.getCamionesRechazadosEnPesadoVigente().then(callback)
    function callback (data) {
      const textRowCount = 'Total de camiones: '
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CAMIONES_RECHAZADOS_BRUTO,
          data: data,
          title: `Camiones rechazados en bruto`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            print: false,
            pagination: false,
            tableBodyMaxHeight: '520px',
            showRowCount: true,
            textRowCount
          }
        },
        id: TABLA_CAMIONES_RECHAZADOS_EN_BRUTO
      })
    }
  }
}
